import { render, staticRenderFns } from "./WorkflowPublished.vue?vue&type=template&id=5f2b987d&scoped=true"
import script from "./WorkflowPublished.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowPublished.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowPublished.vue?vue&type=style&index=0&id=5f2b987d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b987d",
  null
  
)

export default component.exports